import { memo } from 'react';

import { useCanvasTokenNodeSync } from '../hooks/useCanvasTokenNodeSync';

export const CanvasTokenNodeSync = memo(() => {
  useCanvasTokenNodeSync();

  return null;
});

CanvasTokenNodeSync.displayName = 'CanvasTokenNodeSync';
